@if (showNavigationRedesign || isPublicNavigationEnabled()) {
  <ftr-app-layout [routeData]="routeData"> <ng-container *ngTemplateOutlet="childContent" /></ftr-app-layout>
} @else {
  <ftr-app-layout-legacy [logoData]="logoData">
    <ng-container *ngTemplateOutlet="childContent" />
  </ftr-app-layout-legacy>
}

<ng-template #childContent><ng-content /></ng-template>
